import { officialPromotixAppLogoutUrl } from './promotixNavUrls';

/**
 * After Sharetribe logout, clear the PromoTix seller/dashboard session as well.
 * Cookies on app.promotix.com (or staging) are not readable from the reseller origin;
 * loading the official app logout URL in a hidden iframe lets that origin run its normal
 * logout (HttpOnly/session clearance). reseller and app share registrable domain promotix.com.
 *
 * Optional REACT_APP_PROMOTIX_APP_LOGOUT_URL overrides the full URL (must be HTTPS on deployed envs).
 */
export function triggerPromotixAppLogout() {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return;
  }

  const url = officialPromotixAppLogoutUrl();
  if (!url || !/^https?:\/\//i.test(url)) {
    return;
  }

  const iframe = document.createElement('iframe');
  iframe.setAttribute('aria-hidden', 'true');
  iframe.tabIndex = -1;
  iframe.title = 'PromoTix logout';
  iframe.style.cssText =
    'position:absolute;width:0;height:0;border:0;clip:rect(0,0,0,0);visibility:hidden';
  iframe.src = url;
  document.body.appendChild(iframe);

  window.setTimeout(() => {
    try {
      if (iframe.parentNode) {
        iframe.parentNode.removeChild(iframe);
      }
    } catch (e) {
      // ignore
    }
  }, 12000);
}
